<template>
    <div>
        <!-- <div v-if="path != '/message'" class="footer_container">
        <div class="content">
            <div class="site">
                <p class="run_time">
                    <svg-icon icon-class="shandian"></svg-icon>
                    <span>本站居然运行了
                        <strong>{{ day }}</strong> 天
                        <strong>{{ hours }}</strong> 时
                        <strong>{{ minute }}</strong> 分
                        <strong>{{ second }}</strong> 秒
                    </span>
                </p>
                <p>
                    Copyright©2022-2023 <a href="https://gitee.com/quequnlong/seven-blog" target="_blank">质文教育</a>
                    <a href="https://beian.miit.gov.cn/" target="_blank" style="margin-left: 10px">{{
                        $store.state.webSiteInfo.recordNum
                    }}</a>
                </p>

            </div>
            <div class="site-number">
                <span class="site_pv">
                    <i class="iconfont icon-fangwenliang"></i>
                    访问量
                    <em class="pv_num">
                        {{ this.$store.state.siteAccess }}
                    </em>
                </span>

                <span class="site_uv">
                    <i class="el-icon-user-solid"></i>
                    访客量
                    <em class="uv_num">
                        {{ this.$store.state.visitorAccess }}
                    </em>
                </span>
            </div>
        </div>
    </div> -->
    <div class="footer-content">
            <div style="display:flex;justify-content: center;">
                <div class="content_item">
                    <div class="site_name">
                        <img height="35px" src="http://img.zhiwenjiaoyu.cn/img/zhiwen.jpg">
                        <div class="title" style="margin-left:10px">质文教育</div>
                    </div>
                  <router-link :to="'/'" class="tips jump">毕业助力站</router-link>
                </div>
                <div class="content_item">
                    <div class="title">联系我们</div>
                    <img height="100px" src="http://img.zhiwenjiaoyu.cn/img/wechat.jpg">
                    <router-link :to="'/about'" class="tips jump">微信客服</router-link>
                    <router-link :to="'/about'" class="tips jump">联系我们</router-link>
                </div>
                <div class="content_item">
                    <div class="title">资源</div>
                    <router-link :to="'/categorys'" class="tips jump">论文示范</router-link>
                    <router-link :to="'/res-download'" class="tips jump">资源下载</router-link>
                    <router-link :to="'/check'" class="tips jump">论文查重</router-link>
                    <router-link :to="'/down'" class="tips jump">论文降重</router-link>
                    <router-link :to="'/ai'" class="tips jump">AI写作</router-link>
                </div>
            </div>
            <div class="bottom_content">
                <span class="tips">{{ $store.state.webSiteInfo.recordNum }}</span>
                <span class="tips" style="margin-left:20px;margin-right:4px">Copyright©2022-2023</span>
                <span class="tips">质文教育</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            path: null,
            day: "",
            hours: "",
            minute: "",
            second: "",
            url: "https://nimg.ws.126.net/?url=http%3A%2F%2Fdingyue.ws.126.net%2F2020%2F0601%2Fba14f84ep00qb7neh000xd200jx00bog00gn009q.png&thumbnail=650x2147483647&quality=80&type=jpg"
        }
    },
    watch: {

        $route(newVal, old) {
            this.path = newVal.fullPath
        }
    },
    created() {
        this.timer = setInterval(this.runTime, 1000);
    },
    methods: {
        runTime() {
            var timeold =
                new Date().getTime() -
                new Date(1627747200000).getTime();
            var msPerDay = 24 * 60 * 60 * 1000;
            var daysold = Math.floor(timeold / msPerDay);
            var day = new Date();
            this.day = daysold;
            this.hours = day.getHours();
            this.minute = day.getMinutes();
            this.second = day.getSeconds();
        },
    }
}
</script >
<style lang="scss" scoped >
.footer-content{
    // margin-top: 30px;
    height: 300px;
    background-color: #272d36;
    color: #fff;
    position: relative;
    .bottom_content{
        padding-top: 10px;
        text-align: center;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0px;
        width: 100%;
        border-top: 1px solid rgba(233,233,233,.1);
    }
    .content_item{
        width: 350px;
        padding-top:30px;
        img{
            margin-top:10px;
        }
    }
    .site_name{
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        height: 35px;
        img{
            border-radius: 4px;
            margin: 0;
        }
    }
    .tips{
        color: #999;
        font-size: 14px;
        line-height: 30px;
    }
    .jump{
        cursor: pointer;
        display:block;
        text-decoration: none;
    }
    .title{
        color: #ccc;
        font-weight: 500;
        font-size: 1.5em;
    }
}
@keyframes bgSize {
    0% {
        background-size: 300% 100%;
    }

    100% {
        background-size: 100% 100%;
    }
}

@keyframes yb {
    10% {
        transform: rotate(15deg);
    }

    20% {
        transform: rotate(-10deg);
    }

    30% {
        transform: rotate(5deg);
    }

    40% {
        transform: rotate(-5deg);
    }

    50%,
    100% {
        transform: rotate(0deg);
    }
}

.footer_container {
    padding: 15px 20px;
    position: relative;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--footer-background-color);
    background-position: 100% 0;
    animation: bgSize 5s infinite ease-in-out alternate;
    // margin-top: 50px;

    .content {
        margin: 0 auto;
        position: relative;
        text-align: center;

        .site {
            font-size: 14px;
            color: var(--text-color);
            margin-left: 10px;

            p {
                margin: 10px 0;
            }

            a {
                text-decoration: none;
                color: var(--text-color);

                &:hover {
                    color: var(--theme-color);
                }
            }

            .run_time {
                height: 20px;
                align-items: center;

                svg {
                    width: 19px;
                    height: 19px;
                    vertical-align: -4px;
                    animation: yb 1s linear infinite;
                }

                span {
                    line-height: 20px;
                    font-size: 14px;
                    padding-left: 5px;

                    strong {
                        color: var(--theme-color);
                    }
                }
            }
        }

        .site-number {

            i {
                display: inline-block;
                font-size: 12px;
            }

            .site_pv,
            .site_uv,
            .online_user {
                position: relative;
                display: inline-block;
                margin-right: 4px;
                height: 24px;
                padding-left: 10px;
                line-height: 24px;
                overflow: hidden;
                font-size: 12px;
                font-weight: 700;
                color: var(--background-color);
                background: var(--text-color1);
                border-radius: 5px;
            }

            .pv_num,
            .uv_num,
            .online_num {
                display: inline-block;
                font-size: 12px;
                padding: 0 15px;
            }

            .pv_num {
                background: linear-gradient(0deg, #d0339b, #d03336);
            }

            .uv_num {
                background: linear-gradient(0deg, #e2c63a, #f58044);
            }

            .online_num {
                background: linear-gradient(0deg, #367eda, #964fdb);

            }


        }

    }
}
</style>
